import {Component, Injector, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {JWT_TOKEN_KEY} from "../../_constants/common.constant";
import {BaseComponentDirective} from "../../_shared/base/base.component";
import {MatMenuTrigger} from "@angular/material/menu";
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class RegisterComponent extends BaseComponentDirective implements OnInit {
    resultForm: any = {};
    form: FormGroup = this.formBuilder.group({
        fullName: ['', [Validators.required, Validators.minLength(6), Validators.min(6)]],
        email: ['', [Validators.required, Validators.email]],
        password: ['', [Validators.required, Validators.minLength(8)]],
        mobileNumber: [
            '',
            [
                Validators.required,
                Validators.pattern('[- +()0-9]+'),
                Validators.minLength(10),
                Validators.maxLength(14),
            ],
        ],
        referredBy: ['', []],
    });

    loading = false;
    submitted = false;
    typePassword = true;
    suggestedPassword = '';

    strength: string = '';
    strengthClass: string = '';

    @ViewChild(MatMenuTrigger) matMenuTrigger!: MatMenuTrigger; // Access MatMenuTrigger

    constructor(
        injector: Injector,
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private clipboard: Clipboard
    ) {
        super(injector);
    }

    override ngOnInit(): void {
        super.ngOnInit();
        this.form.controls.password.valueChanges.subscribe(r => {
            this.checkPasswordStrength();
        })
    }

    get f() {
        return this.form.controls;
    }

    onSubmit(): void {
        this.submitted = true;
        this.resultForm = this.check(this.form);
        if (this.check(this.form)) {
            console.log(this.resultForm)
            this.form.enable();
            this.submitted = false;
            return;
        }

        this.form.disable();

        const {fullName, email, password, mobileNumber, referredBy} = this.form.value;

        this.loading = true;

        this.authService.register(fullName, email.toLowerCase(), password, referredBy, mobileNumber).then((data) => {
            localStorage.setItem(JWT_TOKEN_KEY, data.token);
            this.currentUser();
        }, _ => {
            this.form.enable();
            this.submitted = false;
        });


    }

    currentUser(): void {
        this.authService.profile().then((res) => {
            this.profileMsg.changeMessage(res);
            setTimeout(() => {
                this.loading = false;
                this.router.navigate(['/billing'], {relativeTo: this.route}).then();
            }, 1000);

        }, (err) => {
            console.log(err);
        });
    }

    validatePhone(): void {
        const control = this.form.get('mobileNumber');
        let input = control?.value || '';
        input = input.replace(/\D/g, '').substring(0, 10);
        let size = input.length;
        if (size > 0) {
            input = '(' + input;
        }
        if (size > 3) {
            input = input.slice(0, 4) + ')' + input.slice(4);
        }
        if (size > 6) {
            input = input.slice(0, 8) + '-' + input.slice(8);
        }

        control?.setValue(input);
    }

    goHome(): void {
        document.location.href = 'https://www.getcertwallet.com';
    }

    copyPassword() {
        this.form.controls.password.setValue(this.suggestedPassword);
        this.clipboard.copy(this.suggestedPassword);
    }


    showPasswordSuggestion(event: MouseEvent) {
        this.suggestedPassword = this.ui.generateStrongPassword();
        this.matMenuTrigger.openMenu();
    }

    checkPasswordStrength(): void {
        let password = this.form.controls.password.value;

        const strengthLevels = {
            weak: { regex: /^.{0,5}$/, text: 'Weak', class: 'weak' },
            medium: { regex: /^(?=.*[A-Za-z])(?=.*\d).{6,10}$/, text: 'Medium', class: 'medium' },
            strong: { regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}$/, text: 'Strong', class: 'strong' }
        };

        if (strengthLevels.strong.regex.test(password)) {
            this.strength = strengthLevels.strong.text;
            this.strengthClass = strengthLevels.strong.class;
        } else if (strengthLevels.medium.regex.test(password)) {
            this.strength = strengthLevels.medium.text;
            this.strengthClass = strengthLevels.medium.class;
        } else {
            this.strength = strengthLevels.weak.text;
            this.strengthClass = strengthLevels.weak.class;
        }
    }

}
